package com.arena_web.analytics

import kotlinx.serialization.Serializable

/**
 * Single client analytics event, mirroring the backend contract for
 * `POST /api/v1/analytics/events/batch`.
 *
 * Allowed names: `session_start`, `screen_view`, `app_open`, `app_background`,
 * and `click.<element>` where element is lowercase `[a-z0-9_-]+`.
 */
@Serializable
data class AnalyticsEventDto(
    val name: String,
    val clientTs: Long,
    val sessionId: String,
    val screen: String? = null,
    val params: Map<String, String> = emptyMap(),
)

/** Batch envelope — max 50 events per request. */
@Serializable
data class AnalyticsBatchRequest(
    val deviceId: String,
    val appVersion: String,
    val deviceType: String,
    val locale: String,
    val events: List<AnalyticsEventDto>,
)
